import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { ArrowForward } from '@one-thd/sui-icons';
import { analytics } from '../../../../core/Constants';
import { analyticsStash } from '../../../../common/utils/AnalyticsUtils';
import { floorNumberWithCommas } from '../../../../common/utils/CurrencyUtils';
import { getAccrualData, getHostCURL, getImageURL } from '../../../../common/utils/CardUtils';
import { ProgressTracker } from '../../../../common/ProgressTracker/ProgressTracker';
import { OffersCardTile, OffersCardTileDynamicIcon } from './OffersCardTile';

/*
Handles State 1 - 4
State 4: Available Perk Count
State 3: New Perk Unlocked
State 2: Perks Expiring Count
State 1: Perks Complete
 */

export const PerkWithStaticIcon = (props) => {
  const {
    analyticsMessage,
    analyticsLinks,
    label = 'Well Done,',
    sublabel = '',
    refLink = '/myaccount/proXtraRewards',
    linkText = 'View Your Perks',
    imgUrl = 'Pro-Xtra_Perk_Icon-whiteFill.svg',
  } = props;
  return (
    <OffersCardTile
      imageURL={imgUrl}
      imageClass="sui-w-100 sui-pt-1"
      analyticsMessage={analyticsMessage}
      analyticsLinks={analyticsLinks}
      refLink={refLink}
      altText="Perk Icon"
      linkText={linkText}
    >
      <>
        <Typography variant="body-base" weight="bold" height="normal">
          {label}
        </Typography>
        {!!sublabel && (
          <Typography variant="body-base" weight="regular" height="normal">
            {sublabel}
          </Typography>
        )}
      </>
    </OffersCardTile>
  );
};

export const ProgressPerk = ({ perkSummary }) => {
  const perkData = getAccrualData(perkSummary);
  const amountRequired = perkData?.spendForNextPerk ?? 0;
  const amount = floorNumberWithCommas(amountRequired, 0);
  const percentage = Number.parseInt(perkSummary?.perkCurrentTierProgressPercentage, 10);
  const icon = (
    <div className="sui-w-100 sui-pt-1">
      <div className="">
        <ProgressTracker percentage={percentage} />
      </div>
    </div>
  );

  return (
    <OffersCardTileDynamicIcon
      icon={icon}
      analyticsMessage={analytics.ANALYTICS_MESSAGE.Progress_Until_Next_Perk}
      analyticsLinks={analytics.ANALYTICS_LINKS.VIEW_PERKS}
      refLink="/myaccount/proXtraRewards"
      linkText="View Your Perks"
    >
      <Typography variant="body-base" weight="bold" height="normal">
        ${amount} Until Next Perk
      </Typography>

    </OffersCardTileDynamicIcon>
  );
};

export const OffersProCreditCard = ({ perkSummary }) => {
  const perkData = perkSummary ? getAccrualData(perkSummary) : null;
  const amountRequired = perkData?.spendForNextPerkWithPxcc ?? 0;
  const amount = floorNumberWithCommas(amountRequired, 0);

  return (
    <div className="sui-w-full">
      <a
        className="sui-flex sui-flex-row sui-justify-between sui-w-full sui-py-3 sui-px-0 sui-items-center"
        href={getHostCURL('/myaccount/proXtraRewards')}
        rel="noreferrer"
        onClick={() => {
          analyticsStash(
            'welcomeCard',
            analytics.ANALYTICS_MESSAGE.ProXtra_Credit_Card,
            analytics.ANALYTICS_LINKS.VIEW_PERKS
          );
        }}
      >
        <div>
          <img
            src={getImageURL('WelcomeCard/active_perks_PLCC.svg')}
            width="46px"
            height="28px"
            alt="paintImage"
          />
        </div>
        <div className="sui-flex sui-flex-col sui-justify-center sui-items-start sui-mx-5 sui-w-full">
          <Typography variant="body-base" weight="bold" height="normal">
            ${amount} Until Next Perk
          </Typography>
          <Typography variant="body-base" weight="regular" height="normal">
            with Pro Xtra Credit Card
          </Typography>
        </div>
        <div className="sui-flex sui-flex-row sui-justify-end sui-items-center sui-pr-0">
          <ArrowForward size="small" />
        </div>
      </a>
    </div>
  );
};
